module.exports = __webpack_public_path__ + "static/media/log-out.23b83494.svg";